import React from "react"
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import findIndex from 'lodash/findIndex'
import shortid from 'shortid'
import {
  Label,
  CustomInput,
} from 'reactstrap'
import moment from '../../../lib/moment.js'
import { findLOBName, findNameByID, selectStatusColor, selectStatusWord } from '../../../function'
import { ShowRemark } from '../form'
import RemarkIcon from '../../../static/images/remark-icon.svg'
import { FONTS } from '../../../constants'

class Header extends React.Component {
  state={ showRemark: false }

  selectApprovalWord = (status) => {
    if (status === 'PENDING') return 'Pending'
    else if (status === 'NONSUMMIT') return 'Unsubmitted'
    else if (status === 'APPROVED') return 'Approved'
    else if (status === 'REJECTED') return 'Rejected'
    else if (status === 'NOTREQUIRE') return 'Not Require'
    return ''
  }

  selectApprovalColor = (status) => {
    if (status === 'PENDING') return '#F0AD4E'
    else if (status === 'NONSUMMIT') return '#428BCA'
    else if (status === 'APPROVED') return '#5CB85C'
    else if (status === 'REJECTED') return '#D9534F'
    else if (status === 'NOTREQUIRE') return '#333333'
    return ''
  }

  showRemark = () => {
    const project_snapshots = get(this.props, 'project_snapshots', [])
    const employees = get(this.props, 'employees', [])
    const snapshotID = findIndex(project_snapshots, {
      snapshot_id: get(this.props, 'selectedVersion'),
    })
    let snapshot = {}
    if (snapshotID > -1) {
      snapshot = project_snapshots[snapshotID]
      snapshot.version = snapshotID + 1
      const user = find(employees, {
        value: snapshot.updated_by,
      })
      snapshot.saved_by = user ? `${user.emp_code} - ${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
      this.setState({
        showRemark: !this.state.showRemark,
        snapshot,
      })
    }
  }

  createOptions = () => {
    const options = [{ snapshot_id: '', label: 'Current Version' }]
    let project_snapshots = get(this.props, 'project_snapshots', [])
    project_snapshots = orderBy(project_snapshots, 'updated', 'desc')
    let key = project_snapshots.length
    project_snapshots.map(snapshot => {
      options.push({
        snapshot_id: snapshot.snapshot_id,
        label: `Version ${key} - ${moment(snapshot.updated).format('DD/MM/YYYY')}`,
      })
      key--
      return snapshot
    })
    return options
  }

  render() {
    const selectedVersion = get(this.props, 'selectedVersion')
    const projectByID = get(this.props, 'projectByID')
    const clientName = findNameByID(get(projectByID, 'client_id'), get(this.props, 'clients'))
    const keyPM = get(this.props, 'users', []).find(u => u._id === get(projectByID, 'key_project_manager_id'))

    return (
      <Container>
        <ShowRemark
          open={ this.state.showRemark }
          toggle={ () => this.setState({ showRemark: !this.state.showRemark }) }
          snapshot={ this.state.snapshot }
        />
        <Row>
          <ColNum>
            <TextLabel >Project Code</TextLabel>
            <TextInfo>{ get(projectByID, 'project_code') }</TextInfo>
          </ColNum>
          <ColNum>
            <TextLabel >Client</TextLabel>
            <TextInfoCut>{ clientName }</TextInfoCut>
            <div className='tooltip'>{ clientName }</div>
          </ColNum>
          <ColNum>
            <TextLabel >Project Name</TextLabel>
            <TextInfoCut>{ get(projectByID, 'name') }</TextInfoCut>
            <div className='tooltip'>{ get(projectByID, 'name') }</div>
          </ColNum>
          <ColNum>
            <TextLabel >LOB</TextLabel>
            <TextInfo>{ findLOBName(get(projectByID, 'lob_id'), get(this.props, 'lobs')) }</TextInfo>
          </ColNum>
          <ColNum>
            <TextLabel >Key PM</TextLabel>
            <TextInfo>{ keyPM && `${keyPM.first_name} ${keyPM.last_name}` }</TextInfo>
            <div className='tooltip'>{ keyPM && `${keyPM.first_name} ${keyPM.last_name}` }</div>
          </ColNum>
          <ColNum>
            <TextLabel >Start Date</TextLabel>
            <TextInfo>{ moment(get(projectByID, 'start_date')).format('DD/MM/YYYY') }</TextInfo>
          </ColNum>
          <ColNum>
            <TextLabel >End Date</TextLabel>
            <TextInfo>{ moment(get(projectByID, 'end_date')).format('DD/MM/YYYY') }</TextInfo>
          </ColNum>
          <ColNum>
            <TextLabel >Status</TextLabel>
            <TextInfo style={ { color: selectStatusColor(get(projectByID, 'project_status')) } }>{ selectStatusWord(get(projectByID, 'project_status')) }</TextInfo>
          </ColNum>
          { (get(projectByID, 'project_type') !== 'COMMON') &&
            <ColNum>
              <TextLabel >Approval Status</TextLabel>
              <TextInfo style={ { color: this.selectApprovalColor(get(projectByID, 'project_approve_status')) } } >{ this.selectApprovalWord(get(projectByID, 'project_approve_status')) }</TextInfo>
            </ColNum>
          }
          <ColNum style={ { display: 'flex' } }>
            { selectedVersion !== '' &&
            <Icon src={ RemarkIcon } onClick={ () => this.showRemark() } />
            }
            <CustomDropdown
              id={ shortid() }
              type='select'
              value={ selectedVersion }
              onChange={ (e) => get(this.props, 'selectVersion')(e) }
            >
              { this.createOptions().map((s) =>
                <option key={ shortid() } value={ s.snapshot_id }>{ s.label }</option>
              ) }
            </CustomDropdown>
          </ColNum>
        </Row>
      </Container>
    )
  }
}

export default Header

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const Container = styled.div`
  width: 100%;
  min-height: 45px;
  background-color: #FFFFFF;
`
const ColNum = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 200px;
  font-size: 12px;
  margin-bottom: 0px;
  padding: 10px 16px;

  span {
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    pointer-events:none;
  }

  span:after {
    content:"";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events:initial;
  }

  .tooltip {
    width: 100%;
    max-width: 300px;
    font-size: 12px;
    top: 50px;
    background-color: #fff;
    padding: 5px;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.3);
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
  }

  span:hover + .tooltip,
  .tooltip:hover {
    transition: opacity 0s ease;
    transition-delay: 1s;
    opacity: 1;
    visibility: visible;
  }
`
const TextLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: 10px;
  margin-bottom: 0px !important;
`
const TextInfo = styled.span`
  overflow: hidden;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const TextInfoCut = styled.span`
  overflow: hidden;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  width: 150px;
  padding-bottom:5px;
`
const CustomDropdown = styled(CustomInput)`
  font-family:${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width : 150px;
`
const Icon = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 5px;
  margin-bottom: auto;
  margin-top: auto;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/project-information/header/index.js